import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client, { apiCall } from '../api/client';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/Loader';

export default function Home() {
  const { user } = useAuth();
  const [networks, setNetworks] = useState([]);
  const [loadingNetworks, setLoadingNetworks] = useState(true);

  useEffect(() => {
    apiCall(client.get('/network/get_list'))
      .then(setNetworks)
      .catch(() => setNetworks([]))
      .finally(() => setLoadingNetworks(false));
  }, []);

  return (
    <>
      <section className="hero">
        <div className="container">
          <h1>One RPC endpoint.<br />Every chain you need.</h1>
          <p>
            NodexaRPC gives you fast, dependable JSON-RPC access across every major EVM network
            from a single API key — so you can ship, scale, and monitor your on-chain traffic
            without standing up and maintaining infrastructure yourself.
          </p>
          <div className="hero-actions">
            {user ? (
              <Link to={user.isAdmin ? '/admin' : '/dashboard'} className="btn btn-primary">Go to dashboard</Link>
            ) : (
              <Link to="/signup" className="btn btn-primary">Start building for free</Link>
            )}
            <Link to="/pricing" className="btn btn-outline">View pricing</Link>
          </div>
        </div>
      </section>

      {loadingNetworks ? (
        <section className="section" style={{ paddingTop: 0, paddingBottom: 0, textAlign: 'center' }}>
          <Loader full={false} />
        </section>
      ) : networks.length > 0 && (
        <section className="section" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="network-chip-row">
              {networks.map((n) => (
                <span key={n.uniqueId} className="network-chip">{n.name}</span>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Built for teams shipping on-chain</h2>
            <p>Everything you need to run production dApp infrastructure without operating nodes.</p>
          </div>
          <div className="feature-grid">
            <div className="feature-card">
              <h3>One API key, every network</h3>
              <p>Point your existing web3 library at a single NodexaRPC endpoint per network — no code changes beyond the RPC URL.</p>
            </div>
            <div className="feature-card">
              <h3>Built-in redundancy</h3>
              <p>Every network runs on redundant endpoints behind the scenes, so a single outage never takes your requests down.</p>
            </div>
            <div className="feature-card">
              <h3>Usage-based credits</h3>
              <p>Pay for what you use. Every JSON-RPC method has a transparent credit cost, visible on our API Credits page.</p>
            </div>
            <div className="feature-card">
              <h3>Real-time usage dashboard</h3>
              <p>Track daily and monthly credit consumption, request logs, and rate limits from your dashboard.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
